export default "__VITE_ASSET__CSHD7FLh__"